import { useTranslation } from 'react-i18next';
import { FieldType, useForm, validateMaxLength, validateRequired } from 'src/hooks/useForm';
import { Button } from 'src/components/Buttons/Button';
import { Input } from 'src/components/Inputs/Input';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { MAX_EMAIL_LENGTH, MAX_PASSWORD_LENGTH } from 'src/constants';

const SupportModal = () => {
  const { t } = useTranslation();
  const {
    errors,
    fieldsProps: { emailProps, passwordProps },
    touched,
    isFormValid
  } = useForm<{ email: FieldType.Text; password: FieldType.Text }>({
    email: {
      placeholder: `${t('general.email')}`,
      fieldType: FieldType.Text,
      validation: [validateRequired, validateMaxLength(MAX_EMAIL_LENGTH)]
    },
    password: {
      placeholder: `${t('general.password')}`,
      fieldType: FieldType.Text,
      validation: [validateRequired, validateMaxLength(MAX_PASSWORD_LENGTH)]
    }
  });

  return (
    <ModalWrapper>
      <div className="flex flex-col items-center gap-[15px] p-[15px] w-[300px] r_xsm:w-full py-[20px]">
        <p className="text-[24px] text-supm_title font-bold tracking-[0.03em]">
          {t('modalSupport.title')}
        </p>
        <p className="font-medium text-[12px] text-supm_text text-center w-[80%]">
          {t('modalSupport.subtitle')}
        </p>
        <Input {...emailProps} />
        {touched.email && errors.email && (
          <span className="text-supm_errors text-xs">{errors.email}</span>
        )}
        <Input {...passwordProps} />
        {touched.password && errors.password && (
          <span className="text-supm_errors text-xs">{errors.password}</span>
        )}
        <Button disabled={!isFormValid} mode="button-primary" title={`${t('modalSupport.title')}`}>
          {t('modalSupport.title')}
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default SupportModal;
